<script>
    // Stores 
    import { 
        textSite,

    } from '../store.js';  

	// Componentes
    import PageHeader                       from './../components/PageHeader.svelte';
    import { Router, Link, link , Route }   from "svelte-routing";
    import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';    

    // Code
    let titlePage = 'Laudos';

	let itensIcon = [
		{
			title: 'PPCI',
			icon: '<i class="fas fa-fire-extinguisher color-primary fa-3x"></i>',
            text: `Plano de Prevenção e Proteção contra Incêndios.`,
            link: '/contato#assunto=Solicito contato sobre Laudo PPCI'
        },   
		{
			title: 'LTIP',
			icon: '<i class="fas fa-building color-primary fa-3x"></i>',
            text: `Laudo Técnico de Inspeção Predial.`,
            link: '/contato#assunto=Solicito contato sobre Laudo LTIP'
        },   
		{
			title: 'ELÉTRICO',
			icon: '<i class="fas fa-bolt color-primary fa-3x"></i>',
            text: `Elétrico.`,
            link: '/contato#assunto=Solicito contato sobre Laudo ELÉTRICO'
        },   
		{
			title: 'MARQUISES',
			icon: '<i class="fas fa-grip-lines color-primary fa-3x"></i>',
            text: `Marquises.`,
            link: '/contato#assunto=Solicito contato sobre Laudo MARQUISES'
        },   
		{
			title: 'INSTALAÇÕES DE GÁS',
			icon: '<i class="fas fa-burn color-primary fa-3x"></i>',
            text: `Instalações de gás.`,
            link: '/contato#assunto=Solicito contato sobre Laudo INSTALAÇÕES DE GÁS'
        },   
    ];

</script>

<section class="conteudo-internas">
    <PageHeader title={titlePage}></PageHeader>
    <div class="container clearfix text-justify">
        <h2 class="title color-primary mb-20">
            Como estão os Laudos de seu Condomínio?
        </h2>
        <ul>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                PPCI – Plano de Prevenção e Proteção contra Incêndios.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                LTIP – Laudo Técnico de Inspeção Predial.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                ELÉTRICO.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                MARQUISES.
            </li>
            <li class="mb-10">
                <i class="fas fa-check-circle mr-10 color-primary"></i> 
                INSTALAÇÕES DE GÁS.
            </li>
        </ul>
        <p>
            Tais Laudos são <b>OBRIGATÓRIOS</b>, envolvem a segurança de moradores, e do patrimônio.
        </p>
        <p>
            Não finalizar ou não executar as adequações, acarreta pesadas multas. <b>CUIDE E COBRE!</b>
        </p>
        <h2 class="title color-primary mt-35 mb-20">
            Solicite informações sobre os laudos:
        </h2>
        <div class="grid grid-size--1 grid-size-sm--5 grid-gap-20">
            {#each itensIcon as item}
            <a class="card-border card-hover--primary hover-transform" href="{item.link}" title="Ir para {item.title}" >
                {@html item.icon}                
                <h2 class="title mb-20 mt-25">{item.title}</h2>
                <p class="no-breakline--xs mb-0">
                    <small>
                        {item.text}
                    </small>
                </p>
            </a>
            {/each}
        </div>
    </div>
</section>